import { SVGProps } from 'react';

export const ListMode = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        {...props}
    >
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M11.5 13.87a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h25a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5h-25Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h25a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5h-25a2.5 2.5 0 0 1-2.5-2.5v-5.4Zm2.5 13.36a.5.5 0 0 0-.5.5v5.4a.5.5 0 0 0 .5.5h25a.5.5 0 0 0 .5-.5v-5.4a.5.5 0 0 0-.5-.5h-25Zm-2.5.5a2.5 2.5 0 0 1 2.5-2.5h25a2.5 2.5 0 0 1 2.5 2.5v5.4a2.5 2.5 0 0 1-2.5 2.5h-25a2.5 2.5 0 0 1-2.5-2.5v-5.4Z"
            clipRule="evenodd"
        />
    </svg>
);
